import { render, staticRenderFns } from "./BarcodePopup.vue?vue&type=template&id=1b48e603&scoped=true&"
import script from "./BarcodePopup.vue?vue&type=script&lang=js&"
export * from "./BarcodePopup.vue?vue&type=script&lang=js&"
import style0 from "./BarcodePopup.vue?vue&type=style&index=0&id=1b48e603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48e603",
  null
  
)

export default component.exports